/** Tracks expenses the user opened in the editor and clicked Save (reviewed). */

const STORAGE_KEY = 'metrica_reviewed_expenses';

type ReviewedMap = Record<string, true>;

function readAll(): ReviewedMap {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') as ReviewedMap;
  } catch {
    return {};
  }
}

function writeAll(map: ReviewedMap) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function markExpenseReviewed(expenseId: string) {
  const all = readAll();
  all[String(expenseId)] = true;
  writeAll(all);
}

export function isExpenseReviewed(expenseId: string): boolean {
  return Boolean(readAll()[String(expenseId)]);
}
